interface NavbarProps {
  scrolled: boolean;
}

export default function Navbar({ scrolled }: NavbarProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <button
            onClick={() => scrollToSection('home')}
            className="flex items-center cursor-pointer"
          >
            <img
              src="https://static.readdy.ai/image/46842361a9a2459ecf5ba33a5b883dd8/2c1d36c2e1fac0a294d031d943b7fed9.png"
              alt="Sail Rebels Logo"
              className="h-16 md:h-32 w-auto object-contain"
            />
          </button>

          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('home')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-gray-800 hover:text-slate-600' : 'text-white hover:text-amber-300'
              }`}
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('cruising')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-gray-800 hover:text-slate-600' : 'text-white hover:text-amber-300'
              }`}
            >
              Cruising
            </button>
            <button
              onClick={() => scrollToSection('racing')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-gray-800 hover:text-slate-600' : 'text-white hover:text-amber-300'
              }`}
            >
              Racing
            </button>
            <button
              onClick={() => scrollToSection('training')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-gray-800 hover:text-slate-600' : 'text-white hover:text-amber-300'
              }`}
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('gallery')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-gray-800 hover:text-slate-600' : 'text-white hover:text-amber-300'
              }`}
            >
              Gallery
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-gray-800 hover:text-slate-600' : 'text-white hover:text-amber-300'
              }`}
            >
              About Us
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-gray-800 hover:text-slate-600' : 'text-white hover:text-amber-300'
              }`}
            >
              Contact
            </button>
          </div>

          <button
            onClick={() => scrollToSection('contact')}
            className="hidden md:block bg-amber-600 hover:bg-amber-700 text-white px-6 py-2.5 rounded-md text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            Book Now
          </button>
        </div>
      </div>
    </nav>
  );
}